module.exports = __webpack_public_path__ + "img/card-receive.8774ba77.svg";